import { render, staticRenderFns } from "./AdminBookings.vue?vue&type=template&id=3041dac0&scoped=true&"
import script from "./AdminBookings.vue?vue&type=script&lang=js&"
export * from "./AdminBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3041dac0",
  null
  
)

export default component.exports